import { Badge } from "../ui/badge";
import { Mail, Phone, MapPin, Calendar, DollarSign, MessageSquare } from "lucide-react";

const statusStyles = {
  new: "bg-[#FFE5F2] text-[#D60079] border-[#FF008F]/30",
  contacted: "bg-blue-50 text-blue-700 border-blue-200",
  qualified: "bg-amber-50 text-amber-800 border-amber-200",
  won: "bg-green-50 text-green-700 border-green-200",
  lost: "bg-red-50 text-red-700 border-red-200",
};

export default function LeadCard({ lead, onClick }) {
  return (
    <button
      onClick={onClick}
      className="w-full text-left bg-white rounded-2xl border border-[#E2DDD3] shadow-sm hover:shadow-md hover:border-[#FF008F]/40 transition-all p-5 sm:p-6"
      data-testid={`lead-card-${lead.id}`}
    >
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="font-serif-display text-lg sm:text-xl text-[#0F172A]">{lead.name}</h3>
            <Badge variant="outline" className={statusStyles[lead.status] || ""}>{lead.status}</Badge>
            <Badge variant="outline" className="bg-[#EFEAE0] text-[#0F172A] border-[#E2DDD3]">
              {lead.source === "claim_estimate" ? "Claim" : "Contact"}
            </Badge>
            {lead.notes && lead.notes.length > 0 && (
              <Badge variant="outline" className="bg-[#F7F5F0] border-[#E2DDD3] text-[#475569] gap-1">
                <MessageSquare className="w-3 h-3" /> {lead.notes.length}
              </Badge>
            )}
            {lead.estimated_recovery > 0 && (
              <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200 gap-1">
                <DollarSign className="w-3 h-3" /> ${Number(lead.estimated_recovery).toLocaleString()}
              </Badge>
            )}
          </div>
          <div className="mt-2 grid sm:grid-cols-2 gap-1.5 text-sm text-[#0F172A]">
            <span className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-[#1E3A8A]" />{lead.email}</span>
            <span className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-[#1E3A8A]" />{lead.phone}</span>
            {lead.property_address && (
              <span className="flex items-center gap-2 sm:col-span-2 truncate"><MapPin className="w-3.5 h-3.5 text-[#1E3A8A]" />{lead.property_address}{lead.county ? `, ${lead.county}` : ""}{lead.state ? `, ${lead.state}` : ""}</span>
            )}
            {lead.foreclosure_date && (
              <span className="flex items-center gap-2"><Calendar className="w-3.5 h-3.5 text-[#1E3A8A]" />Foreclosure: {lead.foreclosure_date}</span>
            )}
          </div>
          <p className="mt-2 text-xs text-[#64748B]">
            {new Date(lead.created_at).toLocaleString()}
            {lead.utm_source ? ` · via ${lead.utm_source}` : ""}
          </p>
        </div>
        <div className="text-xs text-[#1E3A8A] underline-offset-4 hover:underline shrink-0">View details →</div>
      </div>
    </button>
  );
}
